export const USER_TYPES = {
  ESTATE_MEMBER: "estate_member",
  VTU_USER: "vtu_user",
};

export const hasUserType = (userProfile = {}, type) => {
  const userType = userProfile?.userType;
  if (Array.isArray(userType)) return userType.includes(type);
  if (typeof userType === "string") return userType === type;
};

export const getResolvedUserType = (userProfile = {}) => {
  const userType = userProfile?.userType;

  if (Array.isArray(userType) && userType.length > 0) {
    return userType.includes(USER_TYPES.ESTATE_MEMBER)
      ? USER_TYPES.ESTATE_MEMBER
      : userType[0];
  }
  if (typeof userType === "string" && userType) return userType;

  return USER_TYPES.ESTATE_MEMBER;
};

export const isGeneralUser = (userProfile = {}) =>
  getResolvedUserType(userProfile) === USER_TYPES.VTU_USER;
